import {CustomerResponseBodyV2} from '@dms/api/customer';

import {Nullish} from 'shared/web';

export const isCustomerNaturalPerson = (customer: CustomerResponseBodyV2 | Nullish) =>
  customer?.discriminator === 'NATURAL_PERSON';
